import React, { Component, Fragment } from 'react'
import { FormattedMessage } from 'react-intl';
import { motion } from 'framer-motion'
import { CORRECT, WRONG } from './QuizConstants';
import Image from './components/Image';
import Question from '../Quiz/components/Question/Question'

const initialState = {
    selectedChoices: [],
    validated: false,
    current: 0,
    status: null,
    final: false,
}

class Quiz extends Component {
    state = {
        ...initialState,
        scale: 0,
        opacity: 0,
    };
    componentDidMount() {
        const { questions } = this.props;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState(() => {
            return { ...this.state, questions, showLinkTooltip: false }
        }, this.setQuestionHeight)
    }
    componentDidUpdate(prevProps, prevState) {
        const { questions } = this.props;
        this.setQuestionHeight();
        if (JSON.stringify(prevProps.questions) !== JSON.stringify(questions)) {
            this.setState({ ...this.state, questions: questions.map((item, index) => {
                return {
                    ...prevState.questions[index],
                    ...item
                }
            })})
        }
    }
    setQuestionHeight = () => {
        const { mobile } = this.props;
        if (!mobile) return;
        const illustration = document.querySelector('.question__illustration').offsetHeight;
        const mobileToolbar = document.querySelector('.mobile-toolbar').offsetHeight;
        document.querySelector('.question').style.minHeight = `${(window.innerHeight - (illustration + mobileToolbar) + 20)}px`;
    }
    handleMouseEnter = () => {
        this.setState({ ...this.state, showLinkTooltip: true })
    }
    handleMouseLeave = () => {
        this.setState({ ...this.state, showLinkTooltip: false })
    }
    selectChoice = (key) => {
        const { selectedChoices, current, questions } = this.state;
        const selected = selectedChoices.includes(key);
        const correctChoices = questions[current].choices.filter(item => item.correct);
        if (correctChoices.length === 1) {
            this.setState({ ...this.state, selectedChoices: [] })
        }
        if (selected) {
            this.removeChoice(key);
            return;
        }
        this.setState((state, props) => {
            return { ...state, selectedChoices: [...state.selectedChoices, key] }
        }, this.validateAnswers)
    }
    removeChoice = (key) => {
        const arr = this.state.selectedChoices.filter(elem => elem !== key);
        this.setState((state) => {
            return { ...state, selectedChoices: arr };
        }, this.validateAnswers);
    }
    answerAgain = () => {
        const { questions } = this.state;
        this.setState({ ...initialState, questions, final: this.state.final, current: this.state.current })
    }
    setFinal = () => {
        const { questions } = this.state;
        if (questions.length === this.state.current + 1) {
            this.props.setFinished();
            this.setState({ ...this.state, final: true });
        }
    }
    nextQuestion = () => {
        const { questions } = this.state;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.setState(() => {
            return { ...initialState, questions, current: this.state.current + 1 }
        }, this.setFinal);
    }
    finishQuiz = async () => {
        const { questions } = this.state;
        const correctQuestions = questions.filter(item => item.correct);
        const count = correctQuestions.length;
        await this.props.setCorrectAnswers(count);
        this.props.history.push('/final');
    }
    validateAnswers = () => {
        const { current, selectedChoices, questions } = this.state;
        const { required } = questions[current];
        if (selectedChoices.length === required) {
            this.setState({ ...this.state, validated: true });
        } else {
            this.setState({ ...this.state, validated: false });
        }
    }
    submitAnswers = async () => {
        if (!this.state.validated) return false;
        const { questions, current } = this.state;
        const { choices } = questions[current];
        // stringify to be able to make string comparison
        let selectedChoices = this.state.selectedChoices.sort();
        selectedChoices = JSON.stringify(this.state.selectedChoices);
        // get index of the correct choice, filter empty results
        let correctChoices = choices.map((item, index) => {
            if (item.correct) {
                return index;
            }

            return undefined;
        }).filter(item => item !== undefined);
        correctChoices = JSON.stringify(correctChoices);
        if (correctChoices === selectedChoices) {
            this.setState({ ...this.state, status: CORRECT, questions: questions.map((item, index) => {
                if (index === current) {
                    const obj = { ...item }
                    if (!item.answered) {
                        obj.answered = true;
                        obj.correct = true;
                    }
                    return obj;
                }
                return item;
            }) })
            return;
        }
        this.setState({ ...this.state, status: WRONG, questions: questions.map((item, index) => {
            if (index === current) {
                const obj = { ...item }
                if (!item.answered) {
                    obj.answered = true;
                    obj.correct = false;
                }
                return obj;
            }
            return item;
        }) })
    }
    renderButton = () => {
        const { validated, final, status } = this.state;
        if (status === WRONG) {
            return <button onClick={this.answerAgain} className="btn btn--primary" type="button">
                <span className="label">
                    <FormattedMessage id="quiz.button.again" default="Answer again" />
                </span>
            </button>
        } else if (status === CORRECT && !final) {
            return <button onClick={this.nextQuestion} className="btn btn--primary btn--teal" type="button">
                <span className="label">
                    <FormattedMessage id="quiz.button.next" default="Next question" />
                </span>
                </button>
        } else if (final && status === CORRECT) {
            return <button onClick={this.finishQuiz} className="btn btn--primary btn--teal" type="button">
                <span className="label">
                    <FormattedMessage id="quiz.button.finish" default="Finish Quiz" />
                </span>
                </button>
        } else {
            return <button onClick={this.submitAnswers} className="btn btn--primary" type="button" disabled={!validated}>
                <span className="label">
                    <FormattedMessage id="quiz.button.submit" default="Check answer" />
                </span>
            </button>
        }
    }
    render() {
        const { current, validated, status, selectedChoices, final, questions } = this.state;
        const { mobile } = this.props;
        if (!questions) return null;
        const image = mobile ? questions[current].illustration_mobile : questions[current].illustration;
        const currentQuestion = current + 1;
        const questionsLength = questions.length;
        return (
            <Fragment>
                <div className="container container--ptb-120">
                    <div className="grid grid--fixed">
                        <div className="grid__left align-center">
                            <div className={`question__illustration question__illustration--${current}`}>
                                    {
                                        (status && current !== 5) &&
                                        <motion.span
                                            className="highlight"
                                            animate={{ opacity: [0, 1] }}
                                            transition={{ yoyo: Infinity, duration: .6 }}
                                        />
                                    }
                                    {
                                        current === 5 &&
                                            <div className="highlight">
                                                <span className="link-tooltip">hxxps://portal.smartid.com.reportproblem.addinfo88.io/post.php</span>
                                            </div>
                                    }
                                    <Image animate={{ scale: [0.8, 1.2, 0.8, 1], opacity: [0, 1] }} motion={motion} image={image} />
                                </div>
                            </div>
                        <div className="grid__right">
                            <div className="question__wrap">
                                {
                                    !mobile &&
                                    <div className="question__counter">
                                    <p>
                                        <FormattedMessage
                                            id="quiz.score"
                                            defaultMessage={`Question {currentQuestion} / {questionsLength}`}
                                            values={{currentQuestion, questionsLength}}
                                        />
                                    </p>
                                    </div>
                                }
                                <Question
                                    mobile={mobile}
                                    final={final}
                                    status={status}
                                    finishQuiz={this.finishQuiz}
                                    question={questions[current]}
                                    removeChoice={this.removeChoice}
                                    selectedChoices={selectedChoices}
                                    selectChoice={this.selectChoice}
                                    submitAnswers={this.submitAnswers}
                                    nextQuestion={this.nextQuestion}
                                    answerAgain={this.answerAgain}
                                    validated={validated}
                                />
                            </div>
                        </div>
                    </div>
                </div>
                {
                    mobile &&
                    <div className="mobile-toolbar">
                        <p>{`Question ${current + 1} / ${questions.length}`}</p>
                        {
                            this.renderButton()
                        }
                    </div>
                }
            </Fragment>
        )

    }
}

export default Quiz;
